import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import moment from "moment-timezone";
import { requestExportToken } from "../export.service";
import { isNullUndefined } from "../../common/Helpers";

const createBook = (objBook) => { 
    objBook.id = 0;
    return axios({ method: 'post', url: `/api/SbBook`, headers: authHeaderJson(), data : JSON.stringify(objBook) })
};

const saveBook = (objBook) => {
    return axios.put(`/api/SbBook/${objBook.id}`, objBook, { headers: authHeaderJson() });
};

const addRelatedConcept = (bookId, relatedConceptItem) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/SbBook/relatedconcept/${bookId}`, relatedConceptItem, { headers: authHeaderJson() });
};

const updateRelatedConcept = (relatedConceptId, relatedConceptItem) => {
    return axios.put(`/api/SbBook/relatedconcept/${relatedConceptId}`, relatedConceptItem, { headers: authHeaderJson() });
};

const deleteRelatedConcept = (relatedConceptId) => {
    return axios.delete(`/api/SbBook/relatedconcept/${relatedConceptId}`, { headers: authHeaderJson() });
};

const getBookById = (bookId) => {
    return axios.get(`/api/SbBook/${bookId}`, { headers: authHeaderJson() })
};

const getBookMessageCountById = (bookId, partyId, partyMemberId) => {
    return axios.get(`/api/SbMessage/messagesBook/${bookId}/${partyId}/${partyMemberId}/count`, { headers: authHeaderJson() } )
};

const getBookIdByElementId = (elementId) => {
    return axios.get(`/api/SbBook/element/${elementId}`, { headers: authHeaderJson() })
};


const getUsersBookByBookId = (bookId) => {
    return axios.get(`/api/SbBook/partymember/${bookId}/list`, { headers: authHeaderJson() }) 
};

const getRelatedConceptById = (relatedConceptId) => {
    return axios.get(`/api/SbBook/relatedconcept/${relatedConceptId}`, { headers: authHeaderJson() }) 
};

const getRelatedConceptByBookId = (bookId) => {
    return axios.get(`/api/SbBook/relatedconcept/${bookId}/list/`, { headers: authHeaderJson() }) 
};

const getHomeStadistic = (dt_inicio, dt_fin, status) => {
    if (dt_inicio === null && dt_fin === null) {
        if (isNullUndefined(status)) {
            return axios.get(`/api/SbHome/bookHome`, { headers: authHeaderJson() })     
        }
        else {
            return axios.get(`/api/SbHome/bookHome?status_id=${status}`, { headers: authHeaderJson() })     
        }
    } else {
        if (isNullUndefined(status)) {
            return axios.get(`/api/SbHome/bookHome?dt_inicio=${moment(dt_inicio).format("YYYY-MM-DDT00:00:00.000Z")}&dt_fin=${moment(dt_fin).format("YYYY-MM-DDT23:59:59.999Z")}`, { headers: authHeaderJson() })    
        }
        else {
            return axios.get(`/api/SbHome/bookHome?status_id=${status}&dt_inicio=${moment(dt_inicio).format("YYYY-MM-DDT00:00:00.000Z")}&dt_fin=${moment(dt_fin).format("YYYY-MM-DDT23:59:59.999Z")}`, { headers: authHeaderJson() })    
        }
    }
};

const getHomeStadisticExcelData = async (dt_inicio, dt_fin, status) => {
    const token = await requestExportToken("bookHomeExcelData");
    if (dt_inicio === null && dt_fin === null) {
        if (isNullUndefined(status)) {
            return axios.get(`/api/SbHome/bookHomeExcelData?exportToken=${token}`, { headers: authHeaderJson() })
        }
        else {
            return axios.get(`/api/SbHome/bookHomeExcelData?status_id=${status}&exportToken=${token}`, { headers: authHeaderJson() })
        }
    } else {
        if (isNullUndefined(status)) {
            return axios.get(
                `/api/SbHome/bookHomeExcelData?exportToken=${token}&dt_inicio=${moment(dt_inicio).format("YYYY-MM-DDT00:00:00.000Z")}&dt_fin=${moment(dt_fin).format("YYYY-MM-DDT23:59:59.999Z")}`,
                { headers: authHeaderJson() }
            );
        }
        else {
            return axios.get(
                `/api/SbHome/bookHomeExcelData?status_id=${status}&exportToken=${token}&dt_inicio=${moment(dt_inicio).format("YYYY-MM-DDT00:00:00.000Z")}&dt_fin=${moment(dt_fin).format("YYYY-MM-DDT23:59:59.999Z")}`,
                { headers: authHeaderJson() }
            );
        }
    }
};

export {
    createBook,
    saveBook,
    getBookById,
    getBookMessageCountById,
    getBookIdByElementId,
    getUsersBookByBookId,
    getRelatedConceptById,
    addRelatedConcept,
    updateRelatedConcept,
    getHomeStadistic,
    getHomeStadisticExcelData,
    getRelatedConceptByBookId,
    deleteRelatedConcept
}